import { useFormik } from 'formik'
import Input from 'MediaManager/components/Form/Input'
import { createSignmapIntegrationLink, upsertLink } from 'MediaManager/services/links'
import React, { useEffect, useState } from 'react'
import Button from 'shared/components/Button'
import TinyModal from 'shared/components/TinyModal'
import { errorMessages } from 'shared/settings'

import * as Yup from 'yup'

function SightmapIntegration({ link, onCreated }) {
  const [shown, setShown] = useState()

  const validationSchema = Yup.object().shape({
    asset_id: Yup.string().required(errorMessages.required),
    outbound_link_id: Yup.string().required(errorMessages.required),
    unit_id: Yup.string().required(errorMessages.required)
  })

  const formik = useFormik({
    initialValues: {
      url: link.link_short,
    },
    validateOnChange: false,
    validateOnBlur: true,
    validationSchema,
    // validateOnMount:true,
    onSubmit: async (values) => {
      try {
        const payload = {
          asset_id: values.asset_id,
          outbound_link_id: values.outbound_link_id,
          unit_id: values.unit_id,
          url: link.link_short
        }
        await createSignmapIntegrationLink({
          ...payload,
        })
        const upsertPayload = {
          id: link.id,
          provider: 'sightmap',
          link: link.link,
          configuration: {
            ...link.configuration,
            sightmap: payload,
          },
        }
        await upsertLink(upsertPayload)
        setShown(false)
        onCreated(upsertPayload)
      } catch (error) {
        alert('Error creating link, please check entered data or try again later')
      }
    },
  })

  useEffect(() => {
    formik.setValues({
      asset_id: link.configuration?.sightmap?.asset_id,
      outbound_link_id: link.configuration?.sightmap?.outbound_link_id,
      unit_id: link.configuration?.sightmap?.unit_id,
      unit_number: link.configuration?.sightmap?.unit_number,
    })
  }, [link])

  function hasError(field) {
    return formik.errors[field] && formik.touched[field]
  }

  return (
    <>
      <Button rounded className="ml-[16px]" disabled={!link} onClick={() => setShown(!shown)}>
        Sightmap Integration
      </Button>
      {shown && (
        <TinyModal title="Create SightMap Link">
          <form className="w-full">
            <div>
              <Input
                required
                onChange={formik.handleChange}
                name="asset_id"
                label="Asset ID"
                placeholder="Asset ID"
                value={formik.values.asset_id}
                error={hasError('asset_id') && formik.errors.asset_id}
                onBlur={formik.handleBlur}
              />
            </div>
            <div className="mt-[16px]">
              <Input
                required
                onChange={formik.handleChange}
                name="outbound_link_id"
                label="Outbound Link ID"
                placeholder="Outbound Link ID"
                value={formik.values.outbound_link_id}
                error={hasError('outbound_link_id') && formik.errors.outbound_link_id}
                onBlur={formik.handleBlur}
              />
            </div>
            <div className="mt-[16px]">
              <Input
                required
                onChange={formik.handleChange}
                value={formik.values.unit_id}
                error={hasError('unit_id') && formik.errors.unit_id}
                onBlur={formik.handleBlur}
                name="unit_id"
                label="Unit ID"
                placeholder="Unit ID"
              />
            </div>
           
            <div className="mt-[16px]">
              <Input
                onChange={formik.handleChange}
                name="url"
                value={link.link_short}
                disabled
                label="SightMap Embedded URL"
                error={formik.errors.link_short}
                placeholder="SightMap Embedded URL"
              />
            </div>

            <div className="mt-[32px]">
              <Button rounded className="w-full " variant="secondary" onClick={() => setShown(false)}>
                Cancel
              </Button>
              <Button onClick={formik.submitForm} className="w-full  mt-[16px]" rounded loading={formik.isSubmitting}>
                Execute
              </Button>
            </div>
          </form>
        </TinyModal>
      )}
    </>
  )
}

export default SightmapIntegration
